import React from 'react';

import { withTheme } from '@material-ui/core/styles';
import { ExternalLink } from '../common/Links/ExternalLink';
import { Links } from '../../constants/links';

import { TestID } from '../../testID';

const NavBarCollapsedFooter: React.FC<{ theme: any }> = ({ theme }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-evenly',
      backgroundColor: theme.palette.background.light,
      color: theme.palette.text.primary,
    }}
  >
    <p data-testid={TestID.SideMenuSesamCopyrightNotice}>
      &copy; {new Date().getFullYear()} Sesam.io AS
    </p>
  </div>
);

const NavBarExpendedFooter: React.FC<{ statusBar?: React.ReactNode; theme: any }> = ({
  statusBar,
  theme,
}) => (
  <div
    style={{
      backgroundColor: theme.palette.background.light,
      color: theme.palette.text.primary,
    }}
  >
    <div>
      <ul>
        <li>
          <ExternalLink
            href={Links.SesamDocumentations}
            testId={`${TestID.AppBarMenuLink}-Documentation`}
          >
            Documentation
          </ExternalLink>
        </li>
        <li>
          <ExternalLink href={Links.TermsOfService} testId={`${TestID.AppBarMenuLink}-Terms`}>
            Terms
          </ExternalLink>
        </li>
        <li>
          <ExternalLink href={Links.PrivacyPolicy} testId={`${TestID.AppBarMenuLink}-Privacy`}>
            Privacy
          </ExternalLink>
        </li>
      </ul>
      <p data-testid={TestID.SideMenuSesamCopyrightNotice}>
        &copy; {new Date().getFullYear()} Sesam.io AS
      </p>
    </div>
    {statusBar}
  </div>
);

const ThemedNavBarCollapsedFooter = withTheme(NavBarCollapsedFooter);
const ThemedNavBarExpendedFooter = withTheme(NavBarExpendedFooter);

export { ThemedNavBarCollapsedFooter as NavBarCollapsedFooter };
export { ThemedNavBarExpendedFooter as NavBarExpendedFooter };
